module.exports = __webpack_public_path__ + "bc353cd6ac3657850f2c54d98e9afe62.pdf";